import {
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import moment from 'moment';
import React from 'react';

const PaymentHistory = ({
    reservationDetails,
}: {
    reservationDetails: any;
}) => {
    return (
        <TableContainer sx={{ border: 'none' }}>
            <Table size='small'>
                <TableHead>
                    <TableRow>
                        <TableCell>Amount</TableCell>

                        <TableCell>Status</TableCell>
                        <TableCell>Date</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody
                    sx={{
                        [`& .${tableCellClasses.root}`]: {
                            borderBottom: 'none',
                        },
                    }}
                >
                    {reservationDetails?.guestPaymentHistory.map(
                        (
                            payment: {
                                amount: number;
                                fullyPaidAt?: string;
                                dueDate: string;
                            },
                            index: number,
                        ) => (
                            <TableRow key={index}>
                                <TableCell>
                                    {`$${payment.amount.toFixed(2)} AUD `}{' '}
                                </TableCell>
                                <TableCell>
                                    {payment.fullyPaidAt
                                        ? 'Paid'
                                        : 'Outstanding'}
                                </TableCell>{' '}
                                <TableCell>
                                    {' '}
                                    {payment.fullyPaidAt
                                        ? moment(payment.fullyPaidAt).format(
                                              'DD/MM/YYYY',
                                          )
                                        : moment(payment.dueDate).format(
                                              'DD/MM/YYYY',
                                          )}
                                    {}
                                </TableCell>
                            </TableRow>
                        ),
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PaymentHistory;
